export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            投稿爆料
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            通过大赛发布页面提交作品或发送爆料提名，快速上榜
          </p>

          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
              <div>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className="ri-send-plane-fill text-primary-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-3">
                  mrds参赛入口
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  选择你想要参与的话题赛道，提交你的原创作品参与每日竞技。支持图片、视频和文字等多种格式，快来展示你的创作才华。
                </p>
                <a
                  href="#carousel"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-add-line"></i>
                  立即参赛
                </a>
              </div>

              <div>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                  <i className="ri-flashlight-fill text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-3">
                  发送爆料上榜单
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  发现了优秀的创作者或作品？通过爆料通道提名推荐，审核通过后直接进入榜单候选池，让好内容获得更多曝光机会。
                </p>
                <a
                  href="#ranking"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-fire-line"></i>
                  发送爆料
                </a>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center text-xs md:text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-primary-500"></i>
                  审核时间：工作日 2 小时内
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-file-line text-primary-500"></i>
                  支持格式：JPG / PNG / MP4 / 纯文本
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-primary-500"></i>
                  每日不限投稿次数
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}